import React from 'react';
import './AdUpload.css';
import { useState } from 'react';
import api from '../utils/api';
import { Link } from 'react-router-dom';

const AdUpload = ({
  themeMode = 'night',
  themeMenuOpen = false,
  onToggleThemeMenu,
  onCloseThemeMenu,
  onApplyTheme
}) => {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');

    try {
      if (!file) {
        setError('Файл сонгоно уу');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      const uploaded = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      await api.post('/movies', {
        title: title || `Ad ${Date.now()}`,
        mediaType: 'video',
        position: 'center',
        videoUrl: uploaded.data.file.url
      });

      setMessage('Зар сурталчилгаа амжилттай нэмэгдлээ');
      setTitle('');
      setFile(null);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Upload алдаа');
    }
  };

  return (
    <div className={`app theme-${themeMode}`}>
      <div className={`ad-upload card theme-${themeMode}`} style={{ maxWidth: 560, margin: '40px auto' }}>
        <h2>Зар сурталчилгаа нэмэх</h2>
        <form className="form" onSubmit={submit}>
          <input value={title} onChange={(event) => setTitle(event.target.value)} placeholder="Гарчиг" />
          <input type="file" onChange={(event) => setFile(event.target.files?.[0] || null)} />
          <button type="submit">Upload</button>
          {error && <p className="error">{error}</p>}
          {message && <p className="success">{message}</p>}
        </form>
        <Link to="/">Эхлэл рүү буцах</Link>
      </div>
    </div>
  );
};

export default AdUpload;
